import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <p className="footer-text">© 2025 EJ Business & Co. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
